import React from 'react'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card'
import { Badge } from '../../ui/badge'
import { User } from 'lucide-react'

interface PersonalInformation {
  first_name: string
  middle_name?: string
  last_name: string
  alias?: string
  gender: string
  date_of_birth: string
  place_of_birth: {
    city: string
    state_or_province?: string
    country: string
  }
  nationality: string
}

interface KycPersonalInfoProps {
  personalInfo: PersonalInformation
}

export const KycPersonalInfo: React.FC<KycPersonalInfoProps> = ({ personalInfo }) => {
  const formatName = () => {
    const parts = [
      personalInfo.first_name,
      personalInfo.middle_name,
      personalInfo.last_name
    ].filter(Boolean)
    return parts.join(' ')
  }

  const formatPlaceOfBirth = () => {
    const parts = [
      personalInfo.place_of_birth.city,
      personalInfo.place_of_birth.state_or_province,
      personalInfo.place_of_birth.country
    ].filter(Boolean)
    return parts.join(', ')
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center space-x-2 text-base">
          <User className="h-4 w-4" />
          <span>Personal Information</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="text-xs font-medium text-muted-foreground">Full Name</label>
            <p className="text-base font-semibold">{formatName()}</p>
            {personalInfo.alias && (
              <p className="text-xs text-muted-foreground">
                Also known as: {personalInfo.alias}
              </p>
            )}
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground">Gender</label>
            <div>
              <Badge variant="secondary" className="text-xs">{personalInfo.gender}</Badge>
            </div>
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground">Date of Birth</label>
            <p className="text-sm">{personalInfo.date_of_birth}</p>
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground">Place of Birth</label>
            <p className="text-sm">{formatPlaceOfBirth()}</p>
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground">Nationality</label>
            <p className="text-sm">{personalInfo.nationality}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
